import { TokenIcon } from "../board/TokenIcon";
import { colorHex, formatMoney } from "../../lib/format";
import type { RankedPlayer } from "./resultLogic";

/** Final ranking: place, player and net worth with a bar for comparison. */
export function RankingTable({ ranking, meId }: { ranking: RankedPlayer[]; meId: string | null }) {
  const top = Math.max(1, ...ranking.map((r) => r.worth));
  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse text-left">
        <caption className="sr-only">Rangliste nach Vermögen</caption>
        <thead>
          <tr className="border-b border-line text-sm text-ink-2">
            <th scope="col" className="w-12 py-2 pr-2 font-medium">
              Platz
            </th>
            <th scope="col" className="py-2 pr-4 font-medium">
              Spieler
            </th>
            <th scope="col" className="py-2 text-right font-medium">
              Vermögen
            </th>
          </tr>
        </thead>
        <tbody>
          {ranking.map((r) => {
            const hex = colorHex(r.player.color);
            return (
              <tr key={r.player.id} className="border-b border-line align-middle">
                <td className="py-3 pr-2 font-display text-2xl font-bold tabular-nums text-ink">{r.rank}</td>
                <td className="py-3 pr-4">
                  <div className="flex items-center gap-3">
                    <span
                      className="grid size-11 shrink-0 place-items-center rounded-full border-[3px] bg-surface"
                      style={{ borderColor: hex }}
                    >
                      <TokenIcon token={r.player.token} color={r.player.color} size={28} />
                    </span>
                    <div className="min-w-0">
                      <p className="truncate font-semibold text-ink">
                        {r.player.name}
                        {r.player.id === meId && <span className="font-normal text-ink-2"> (Du)</span>}
                      </p>
                      <p className="text-sm text-ink-2">
                        {r.isWinner ? "Sieger" : r.player.eliminated ? "Ausgeschieden" : "Im Spiel"}
                      </p>
                    </div>
                  </div>
                </td>
                <td className="w-[38%] min-w-28 py-3 text-right">
                  <p className="font-semibold tabular-nums text-ink">{r.player.eliminated ? "–" : formatMoney(r.worth)}</p>
                  <div className="mt-1.5 h-2 w-full rounded-full bg-surface-2" aria-hidden="true">
                    <div
                      className="h-full rounded-full"
                      style={{ width: `${r.player.eliminated ? 0 : Math.max(2, (r.worth / top) * 100)}%`, background: hex }}
                    />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
